export default {
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        width: '100%',
        top: 0,
        left: 0,
        zIndex: 1000
      },
      colorPrimary: {
        backgroundColor: '#ABB8A1'
      },
      barColorPrimary: {
        backgroundColor: '#ffffff'
      }
    }
  }
};
